import { render, staticRenderFns } from "./customPage.vue?vue&type=template&id=c8ff05ce&scoped=true&"
import script from "./customPage.vue?vue&type=script&lang=js&"
export * from "./customPage.vue?vue&type=script&lang=js&"
import style0 from "./customPage.vue?vue&type=style&index=0&id=c8ff05ce&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8ff05ce",
  null
  
)

export default component.exports